module.exports = __webpack_public_path__ + "static/bugfix-2107facd74ab14abf00ee887ce940602.svg";